import { getType } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';

import { IHealthcareApi, IPatient } from '../../interfaces';
import { convertToError } from '../../utils';
import * as actions from './actions';

function* fetchPatients(api: IHealthcareApi) {
  try {
    const patients: IPatient[] = yield call(api.fetchPatients);

    yield put(actions.fetchPatientsSucceeded({ patients }));
  } catch (e) {
    yield put(actions.fetchPatientsFailed(convertToError(e)));
  }
}

export function* patientsSaga(api: IHealthcareApi) {
  yield takeLatest(getType(actions.fetchPatients), fetchPatients, api);
}
